
function stripPem(pem) {
  return pem.replace(/-----BEGIN PUBLIC KEY-----/, "")
            .replace(/-----END PUBLIC KEY-----/, "")
            .replace(/\s+/g, "");
}

function b64ToArrayBuffer(b64) {
  // Valida base64 para evitar InvalidCharacterError
  if (!/^[A-Za-z0-9+/=]+$/.test(b64)) {
    throw new Error("Public key base64 malformado. Verifique seu .env");
  }
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}

async function importPublicKeyFromEnv() {
  const pem = process.env.REACT_APP_CERTIFICATE_PUBLIC_KEY;
  if (!pem) throw new Error("REACT_APP_CERTIFICATE_PUBLIC_KEY ausente");
  const normalized = pem.replace(/\\n/g, "\n").trim();
  if (!normalized.includes("BEGIN PUBLIC KEY")) {
    // WebCrypto exige SPKI (-----BEGIN PUBLIC KEY-----)
    throw new Error("A chave pública deve estar em SPKI (BEGIN PUBLIC KEY)");
  }
  const clean = stripPem(normalized);
  const der = b64ToArrayBuffer(clean);
  return crypto.subtle.importKey(
    "spki",
    der,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
}

/**
 * Criptografa o payload inteiro com AES-256-GCM e "embrulha" a chave AES com RSA-OAEP.
 * Retorna UMA string base64 do blob compacto: [ek | iv | ciphertext+tag].
 * Envie no body como { data: "<essa base64>" }.
 */
export async function encryptWithPublicKey(texto) {
  // NÃO use try/catch que retorna null; estoure o erro para você ver o motivo real
  const publicKey = await importPublicKeyFromEnv();

  // 1) Gera chave AES + IV (12 bytes para GCM)
  const aesKey = await crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt"]
  );
  const iv = crypto.getRandomValues(new Uint8Array(12));

  // 2) Cifra o payload com AES-GCM (ciphertext + tag de 16 bytes no final)
  const encoded = new TextEncoder().encode(texto);
  const ciphertextWithTag = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv }, aesKey, encoded)
  );

  // 3) Exporta a AES (raw 32 bytes) e cifra com RSA-OAEP
  const rawAes = new Uint8Array(await crypto.subtle.exportKey("raw", aesKey));
  const ek = new Uint8Array(
    await crypto.subtle.encrypt({ name: "RSA-OAEP" }, publicKey, rawAes)
  ); // tamanho = modulus/8 (ex.: 256 bytes para RSA-2048)

  // 4) Concatena blob [ek | iv | ciphertext+tag] e retorna base64
  const full = new Uint8Array(ek.length + iv.length + ciphertextWithTag.length);
  full.set(ek, 0);
  full.set(iv, ek.length);
  full.set(ciphertextWithTag, ek.length + iv.length);

  // toBase64
  let bin = "";
  for (let i = 0; i < full.length; i++) bin += String.fromCharCode(full[i]);
  return btoa(bin);
}
